import { Link } from 'gatsby';
import React from 'react';

const ItemMobile = ({ link, title, isTop = false }) => {
  const classes = `block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out ${
    isTop ? '' : 'mt-1'
  }`;

  return /^http/.test(link) ? (
    <a role="menuitem" href={link} className={classes}>
      {title}
    </a>
  ) : (
    <Link role="menuitem" to={link} className={classes}>
      {title}
    </Link>
  );
};

export default ItemMobile;
